import { render } from "./Pre-loader.vue?vue&type=template&id=b1932ca0&scoped=true"
import script from "./Pre-loader.vue?vue&type=script&lang=js"
export * from "./Pre-loader.vue?vue&type=script&lang=js"

import "./Pre-loader.vue?vue&type=style&index=0&id=b1932ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1932ca0"]])

export default __exports__